export const FLOW_STEPS = [
  { id: "identify", label: "Pedido" },
  { id: "items", label: "Itens" },
  { id: "resolution", label: "Resolução" },
  { id: "exchange", label: "Troca" },
  { id: "review", label: "Revisão" },
  { id: "status", label: "Status" },
];

export const RESOLUTION_TYPES = {
  refund: "refund",
  exchange: "exchange",
  storeCredit: "storeCredit",
  giftCard: "giftCard",
  discountCode: "discountCode",
};

export const RESOLUTION_META = {
  refund: {
    label: "Estorno",
    description: "O valor volta no mesmo meio de pagamento da compra.",
  },
  exchange: {
    label: "Troca",
    description: "Escolha outra variação ou produto disponível em estoque.",
  },
  storeCredit: {
    label: "Crédito na loja",
    description: "O valor fica disponível na sua conta da loja para a próxima compra.",
  },
  giftCard: {
    label: "Vale-presente",
    description: "Você recebe um vale-presente para usar quando quiser.",
  },
  discountCode: {
    label: "Cupom de desconto",
    description: "Geramos um cupom para aplicar no checkout.",
  },
};

export const DEFAULT_RESOLUTION_SETTINGS = {
  refund: { enabled: true, method: "shopify" },
  exchange: { enabled: true, policy: "same_product" },
  storeCredit: { enabled: false, bonusPercent: 0 },
  giftCard: { enabled: false, bonusPercent: 0, expiresInDays: 0 },
  discountCode: { enabled: false, bonusPercent: 0, expiresInDays: 0, prefix: "" },
};
